import { Box } from "@mui/material";
import { colorOrNeutral } from "../../misc/projectColors";

// ProjectCode is the 2-character label of a project, so a task names its project
// without the reader having to tell the colours apart. A task with no project shows
// nothing.
export function ProjectCode(props: {
    code: string;

    // color is the project's palette key
    color: string;
    done?: boolean;
}) {
    if (!props.code) return null;

    return (
        <Box component="span" sx={{
            flexShrink: 0,
            fontSize: "0.75rem",
            lineHeight: 1.4,
            fontWeight: 600,
            letterSpacing: 0.5,
            color: props.done ? "text.secondary" : colorOrNeutral(props.color).code,
        }}>
            {props.code}
        </Box>
    );
}
